import { render, staticRenderFns } from "./DetailAttendance.vue?vue&type=template&id=4674b6c8&"
import script from "./DetailAttendance.vue?vue&type=script&lang=js&"
export * from "./DetailAttendance.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports